
const SET_SERVICES_REPORT = (state, payload) => {
  state.services_report = payload;
}

export default {
  SET_SERVICES_REPORT,
}